import React from 'react';

export default function ChevronUpIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(180)"
    >
      <path
        d="M8.791 11.529a.733.733 0 01-.537-.223L4.223 7.283a.745.745 0 010-1.065.751.751 0 011.057 0l3.51 3.511 3.512-3.511a.751.751 0 011.057 0 .748.748 0 010 1.065l-4.023 4.023a.753.753 0 01-.535.223z"
        fill="#494c4e" />
    </svg>
  );
}